export default __webpack_public_path__ + "static/media/500-Error-art.504643f5.png";